import { Input, InputNumber } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import styles from './Components.module.css'


export const ModalinputFormField = ({
    labelFor,
    labelText,
    value,
    onChange,
    disabled = false,
    type = 'text'
  }) => {
    return (
      <div className="mb-1">
        <label
          className="form-label fw-bold w-100"
          htmlFor={labelFor}
          style={{ margin: 0 }}
        >
          {labelText}
          <span>:</span>
        </label>
        {
          type === 'text' &&
          <Input
            value={value}
            onChange={onChange}
            id={labelFor}
            className={styles.inputStyles}
            disabled={disabled}
            style={{
              backgroundColor: disabled ? "#F1F1F1" : "white",
              width: "100%"
            }}
          />
        }
        {
          type === 'number' &&
          <InputNumber
            value={value}
            onChange={onChange}
            id={labelFor}
            className={styles.inputStyles}
            disabled={disabled}
            style={{
              backgroundColor: disabled ? "#F1F1F1" : "white",
              width: "100%",
              borderRadius: 0
            }}
          />
        }
      </div>
    );
  };
  export const ModalinputNumberFormField = ({
    labelFor,
    labelText,
    value,
    onChange,
    disabled = false,
    type = 'text'
  }) => {
    return (
      <div className="mb-1">
        <label
          className="form-label fw-bold w-100"
          htmlFor={labelFor}
          style={{ margin: 0 }}
        >
          {labelText}
          <span>:</span>
        </label>
          <InputNumber
          type="number"
            value={value}
            onChange={onChange}
            id={labelFor}
            className={styles.inputStyles}
            disabled={disabled}
            style={{
              backgroundColor: disabled ? "#F1F1F1" : "white",
              width: "100%",
              borderRadius: 0
            }}
          />
      </div>
    );
  };

  // export const ModalPasswordFormField = ({
  //   labelFor,
  //   labelText,
  //   value,
  //   onChange,
  //   disabled = false,
  //   placeholder = "Enter password"
  // }) => {
  //   return (
  //     <div className="mb-1">
  //       <label
  //         className="form-label fw-bold w-100 mb-2"
  //         htmlFor={labelFor}
  //         style={{ margin: 0 }}
  //       >
  //         {labelText}
  //         <span>:</span>
  //       </label>
  //       <Input.Password
  //         id={labelFor}
  //         value={value}
  //         onChange={onChange}
  //         disabled={disabled}
  //         placeholder={placeholder}
  //         className={styles.inputStyles}
  //         iconRender={(visible) =>
  //           visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
  //         }
  //         style={{
  //           backgroundColor: disabled ? "#F1F1F1" : "white",
  //           width: "100%",
  //           borderRadius: 0
  //         }}
  //       />
  //     </div>
  //   );
  // };

  export const ModalPasswordFormField = ({
    labelFor,
    labelText,
    value,
    onChange,
    placeholder,
    error = false,
  }) => {
    return (
      <div className="mb-1">
        <label
          className="form-label fw-bold w-100"
          htmlFor={labelFor}
          style={{ margin: 0 }}
        >
          {labelText}:
        </label>
        <Input.Password
          id={labelFor}
          placeholder={placeholder}
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
          value={value}
          onChange={onChange}
          style={{
            backgroundColor: error ? "#fff0f0" : "white",
            borderColor: error ? "red" : "#d9d9d9",
            color: error ? "red" : "inherit",
          }}
        />
        {error && (
          <small style={{ color: "red", fontSize: "12px" }}>
            Passwords do not match
          </small>
        )}
      </div>
    );
  };

  